<div cdkTrapFocus class="example-modal-wrapper">
  <div class="modal-close-container">
    <button id="close-modal-cross-btn" type="button" class="close pull-right btn-close-modal" aria-label="Close"
            (click)="modalRef.hide()"
            (keydown.enter)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-header">
      <h3 id="modal-header-title" class="modal-title"
            i18n="@@ExampleModalTitle">Customizable Profile Fields</h3>
    <p id="example-modal-subtitle"  class="muted"
          i18n="@@exampleModalSubtitle">The profile screen appears when a user creates a new account.</p>
  </div>
  <div class="modal-body">
    <img src="assets/images/settings_example.png" alt="Screenshot of the profile screen for new users.
     If the custom dropdown is enabled, the profile fields appear in the following order: first name, last name, custom dropdown, area of focus and role.
     If the custom message is enabled, it will appear after all the input fields." i18n-alt="@@ExampleModaleAltText"/>
  </div>
</div>
